import { clients } from '../lib/https';
import { ConfigurationSettings } from '../models/configuration-settings';

import { FileResponse, UploadFileToLocalStorageResponse } from '/types/storage-type';
import { VectorUploadItem } from '/features/chat/types/chat';

export const uploadFileToLocalStorage = async (
  file: File,
  itemId: string,
  config: ConfigurationSettings
) => {
  const baseUrl = `https://${config.paths.baseUrl}`;
  const url = `${baseUrl}${config.paths.storage.uploadFileToLocalStorage}`;

  const formData = new FormData();
  formData.append('ItemId', itemId);
  formData.append('MetaData', 'null');
  formData.append('Name', file.name);
  formData.append('ParentDirectoryId', 'null');
  formData.append('Tags', 'null');
  formData.append('AccessModifier', 'Private');
  formData.append('Projectkey', config.blocksKey);
  formData.append('File', file);

  return clients.post<UploadFileToLocalStorageResponse>(url, config.blocksKey, formData, {}, true);
};

export const uploadFilesToVectorStorage = async (
  items: VectorUploadItem[],
  model_name: string,
  config: ConfigurationSettings
) => {
  const params = new URLSearchParams({
    model_name: model_name,
  });
  const baseUrl = `https://${config.paths.taskforceBaseUrl}`;
  const url = `${baseUrl}${config.paths.taskforce.uploadAll}?${params.toString()}`;
  const body = items.map((item) => ({ file_id: item.fileId }));

  return clients.post(url, config.blocksKey, JSON.stringify(body));
};

export const archiveConversationById = async (
  conversationId: string,
  config: ConfigurationSettings
) => {
  const baseUrl = `https://${config.paths.taskforceBaseUrl}`;
  const url = `${baseUrl}${config.paths.taskforce.archive}`;
  const body = {
    conversation_id: conversationId,
  };
  return clients.post(url, config.blocksKey, JSON.stringify(body));
};

export const deleteConversationById = async (
  conversationId: string,
  config: ConfigurationSettings
) => {
  const baseUrl = `https://${config.paths.taskforceBaseUrl}`;
  const url = `${baseUrl}${config.paths.taskforce.singleConversation}/${conversationId}`;
  return clients.delete(url, config.blocksKey);
};

export const updateConversationTitleById = (
  conversationId: string,
  title: string,
  config: ConfigurationSettings
) => {
  const baseUrl = `https://${config.paths.taskforceBaseUrl}`;
  const url = `${baseUrl}${config.paths.taskforce.singleConversation}/update-title`;
  const body = {
    conversation_id: conversationId,
    title,
  };
  return clients.post(url, config.blocksKey, JSON.stringify(body));
};

export const getFile = (fileId: string, config: ConfigurationSettings, version?: number) => {
  const params = new URLSearchParams({
    FileId: fileId,
    ProjectKey: config.blocksKey,
  });

  if (version !== undefined) {
    params.append('Version', version.toString());
  }
  const baseUrl = `https://${config.paths.baseUrl}`;
  const url = `${baseUrl}${config.paths.storage.getFile}?${params.toString()}`;

  return clients.get<FileResponse>(url, config.blocksKey);
};
